export const TODO_PRIORITY = {
  URGENT: 'URGENT',
  HIGH: 'HIGH',
  MEDIUM: 'MEDIUM',
  LOW: 'LOW'
};

export const TODO_STATUS = {
  INPROGRESS: 'INPROGRESS',
  POSTPONED: 'POSTPONED',
  PAUSED: 'PAUSED',
  DONE: 'DONE'
};

export const TODO_PRIORITY_LABELS = {
  [TODO_PRIORITY.URGENT]: 'Urgent',
  [TODO_PRIORITY.HIGH]: 'High',
  [TODO_PRIORITY.MEDIUM]: 'Medium',
  [TODO_PRIORITY.LOW]: 'Low'
};

export const TODO_STATUS_LABELS = {
  [TODO_STATUS.INPROGRESS]: 'In Progress',
  [TODO_STATUS.POSTPONED]: 'Postponed',
  [TODO_STATUS.PAUSED]: 'Paused',
  [TODO_STATUS.DONE]: 'Done'
};

export const TODO_STATUS_OPTIONS = Object.keys(TODO_STATUS_LABELS).map((key) => ({
  value: key,
  label: TODO_STATUS_LABELS[key]
}));

export const TODO_PRIORITY_BADGE_COLORS = {
  [TODO_PRIORITY.URGENT]: 'red',
  [TODO_PRIORITY.HIGH]: 'yellow',
  [TODO_PRIORITY.MEDIUM]: 'blue',
  [TODO_PRIORITY.LOW]: 'green'
};

export const TODO_PRIORITY_OPTIONS = Object.keys(TODO_PRIORITY_LABELS).map((key) => ({
  value: key,
  label: TODO_PRIORITY_LABELS[key],
  badgeColor: TODO_PRIORITY_BADGE_COLORS[key]
}));

export const TODO_STATUS_COLUMNS = [
  { id: TODO_STATUS.INPROGRESS, label: 'In Progress', color: 'blue' },
  { id: TODO_STATUS.PAUSED, label: 'Paused', color: 'gray' },
  { id: TODO_STATUS.POSTPONED, label: 'Postponed', color: 'yellow' },
  { id: TODO_STATUS.DONE, label: 'Done', color: 'green' },
];

export const TODO_BODY_MAX_LENGTH = 500;

export const TODO_BODY_FEATURES = ['bold', 'italic', 'bulletList', 'orderedList', 'hardBreak'];
